import i18n from '@/i18n';
import type { Nullish } from 'cesg-shared';

export function translateKey(
  key: Nullish<string | number>,
): string | Nullish<string | number> {
  if (key) {
    return i18n.global.t(key) as string;
  } else return key;
}
